/**
 * Location utilities for live events.
 * Pure TypeScript - no React imports.
 */

/**
 * Builds a Google Maps directions URL for a physical-location event's venue.
 * No API key needed — this is a plain web link, not an embed/JS API call.
 */
export function buildGoogleMapsDirectionsUrl(lat: number, lng: number): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
}
